import { render, staticRenderFns } from "./sparks.vue?vue&type=template&id=38a05466&scoped=true&"
import script from "./sparks.vue?vue&type=script&lang=js&"
export * from "./sparks.vue?vue&type=script&lang=js&"
import style0 from "./sparks.vue?vue&type=style&index=0&id=38a05466&scoped=true&lang=css&"
import style1 from "./sparks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a05466",
  null
  
)

export default component.exports